<template>
    <div class="row align-items-center">
        <div class="col-md-5 text-center text-md-right">
            <i class="border border-3 rounded-circle p-3 fa-2x" :class="[{ 'border-primary text-primary': active, 'border-secondary text-secondary': !active }, icon]"></i>
        </div>
        <div class="col-md-7 text-center text-md-left">
            <span class="mt-2 mt-md-0 badge small font-weight-normal text-uppercase px-0" :class="{ 'text-primary': active, 'text-secondary': !active }">
                {{ title }}
            </span>
            <p class="mb-0 d-none d-md-block">{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Step.vue",
    props: {
        title: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
